import { render, staticRenderFns } from "./CustomerDebitNote.vue?vue&type=template&id=60379ef0&lang=pug&"
import script from "./CustomerDebitNote.vue?vue&type=script&lang=js&"
export * from "./CustomerDebitNote.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "CustomerDebitNote.vue"
export default component.exports